import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("App crashed:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="app-error-fallback" className="min-h-screen bg-black text-white flex items-center justify-center p-6">
          <div className="max-w-md text-center">
            <p className="font-display text-2xl uppercase tracking-tight text-[#E2E30A] mb-3">Something went wrong</p>
            <p className="text-zinc-200 text-sm mb-6">We hit an unexpected error. Reloading usually fixes it. If it keeps happening, please use the Feedback button to let us know.</p>
            <button
              data-testid="app-error-reload"
              onClick={() => window.location.reload()}
              className="bg-[#E2E30A] hover:bg-[#c9ca09] text-black font-semibold uppercase tracking-wider px-6 py-3 transition-colors"
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
